
// import { Firebase, FirebaseRef } from '../lib/firebase';
// import initState from '../store/mainappdata';
import firebase from '../config/database'
import update from 'react-addons-update'; // ES6

export default {
    state: {
        mainappdata: {
            user: {},
            events: {}
        }
    },


    reducers: {
        setuser(state, payload) {
            console.log("in setuser");
            return {
                ...state,
                mainappdata: {
                    ...state.mainappdata,
                    user: payload
                }
            }
        },
        seteventdata(state, payload) {
            console.log("In setevent data for" + payload.key)
            return {
                ...state,
                mainappdata: {
                    ...state.mainappdata,
                    events: {
                        ...state.mainappdata.events,
                        [payload.key]: payload.data
                    }
                }
            }
        },
        updateeventfield(state, payload) {
            var getpath = payload.path.split('/');

            console.log(getpath);
            // return state;
        },
        addsection(state, payload) {
            console.log("In setevent data for" + payload.key)
            return {
                ...state,
                mainappdata: {
                    ...state.mainappdata,
                    events: {
                        ...state.mainappdata.events,
                        [payload.key]: {
                            ...state.mainappdata.events[payload.key],
                            navigation: {
                                menus: payload.data
                            }
                        }
                    }
                }
            }
        },

        updatetrackswithobjects(state, payload) {
            console.log("in update tracks with objects");
            return {
                ...state,
                mainappdata: {
                    ...state.mainappdata,
                    events: {
                        ...state.mainappdata.events,
                        [payload.eventkey]: {
                            ...state.mainappdata.events[payload.eventkey],
                            [payload.type]: payload.data
                        }
                    }
                }
            }
        },

        updatecolordesign(state, payload) {
            console.log("In update color design");
            return {
                ...state,
                mainappdata: {
                    ...state.mainappdata,
                    events: {
                        ...state.mainappdata.events,
                        [payload.eventkey]: {
                            ...state.mainappdata.events[payload.eventkey],
                            extradata: {
                                ...state.mainappdata.events[payload.eventkey].extradata,
                                design: {
                                    ...state.mainappdata.events[payload.eventkey].extradata.design,
                                    [payload.path1]: {
                                        ...state.mainappdata.events[payload.eventkey].extradata.design[payload.path1],
                                        [payload.path2]: payload.color
                                    }
                                }
                            }

                        }
                    }
                }
            }
        },
        updatedatasection(state, payload) {
            console.log("In update color design");
            return update(state, {
                mainappdata: { events: { [payload.eventkey]: { navigation: { menus: { [payload.sectionnumber]: { $merge: payload.data } } } } } }
            });
        },
        updateinfoapp(state, payload) {
            // console.log("In update app info");
            // console.log(payload);
            return update(state, {
                mainappdata: {
                    events: { [payload.eventkey]: { extradata: { $merge: payload.data } } }
                }
            });
        },
        updateobjectdatabytype(state, payload) {
            return update(state, {
                mainappdata: {
                    events: { [payload.eventkey]: { [payload.type]: { [payload.key]: { $set: payload.data } } } }
                }
            });
        },
        updateobjectdatabytypeandsubtype(state, payload) {
            if (state.mainappdata.events[payload.eventkey][payload.type][payload.subtype]) {
                return update(state, {
                    mainappdata: {
                        events: { [payload.eventkey]: { [payload.type]: { [payload.subtype]: { [payload.key]: { $set: payload.data } } } } }
                    }
                });
            } else {
                return update(state, {
                    mainappdata: {
                        events: { [payload.eventkey]: { [payload.type]: { [payload.subtype]: { $set: { [payload.key]: payload.data } } } } }
                    }
                });
            }

        },
    },
    /**
     * Effects/Actions
     */
    effects: (dispatch) => ({
        logindonehome(user) {
            console.log(user);
        },
        logindoneevent(user, test, pathname) {
            console.log("In event master");
            console.log(user);
            dispatch({
                type: "eventmodel/setuser",
                payload: user
            })
            console.log(pathname);
            return new Promise((resolve, reject) => {
                firebase.app.database().ref("myapps/" + pathname).once('value', (snapshot) => {
                    if (snapshot.exists()) {
                        console.log("Got data from firebase for event");
                        console.log(snapshot.val());
                        var data = {};
                        if (snapshot.val() != true) {
                            data = snapshot.val();
                        }
                        if (data.init) {
                            firebase.app.database().ref(data.init + "/" + pathname).once('value', (snap) => {
                                data["extradata"] = snap.val();
                                dispatch({
                                    type: "eventmodel/seteventdata",
                                    payload: { key: pathname, data: data }
                                })
                                resolve({ empty: 2 })
                            });

                        } else {
                            resolve({ empty: 1 });
                        }


                    } else {
                        resolve({ empty: 1 });
                    }
                });
            });

        },
        addnewsection(section, test, pathname) {
            dispatch({
                type: "eventmodel/addsection",
                payload: { key: pathname, data: section }
            })
        },
        updateeventfield(path) {
            dispatch({
                type: "eventmodel/updateeventfield",
                payload: path
            })
        },
        updateobjectwithtracks(data) {
            dispatch({
                type: "eventmodel/updatetrackswithobjects",
                payload: data
            })
        },
        updatedesigncolor(data) {
            dispatch({
                type: "eventmodel/updatecolordesign",
                payload: data
            })
        },
        updatesectiondata(data) {
            dispatch({
                type: "eventmodel/updatedatasection",
                payload: data
            })
        },
        updateappinfo(data) {
            dispatch({
                type: "eventmodel/updateinfoapp",
                payload: data
            })
        },
        updatedataobjectbytype(data) {
            dispatch({
                type: "eventmodel/updateobjectdatabytype",
                payload: data
            })
        },
        updatedataobjectbytypeandsubtype(data) {
            dispatch({
                type: "eventmodel/updateobjectdatabytypeandsubtype",
                payload: data
            })
        },




    }),
};



// WEBPACK FOOTER //
// ./src/models/eventmodel.js